module.exports = __webpack_public_path__ + "static/media/football-carousel-320x480.35c7d496.jpg";